"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var DataSync = _interopRequireWildcard(require("./util/DataSync"));

var Log = _interopRequireWildcard(require("./util/Log"));

var _cache = _interopRequireDefault(require("./util/cache"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Instant Message
 * @public
 */
var Message =
/*#__PURE__*/
function () {
  /**
   * Create a message
   * @param {Webcom/api.DataSnapshot|Object} snapData The data snapshot
   * @param {string} roomId The message's room id
   * @access protected
   */
  function Message(snapData, roomId) {
    _classCallCheck(this, Message);

    var values = Object.assign({}, snapData.val());
    /**
     * The message unique id
     * @type {string}
     */

    this.uid = snapData.name();
    /**
     * The room uid
     * @type {string}
     */

    this.roomId = roomId;
    /**
     * The message
     * @type {string}
     */

    this.text = values.text;
    /**
     * The message sender
     * @type {string}
     */

    this.from = values.from;
    /**
     * Joined date
     * @type {number}
     */

    this._created = values._created;
  }
  /**
   * Edit the text message. Only the sender or moderator/owner of the room can edit a message.
   * @param {string} newText The new message
   * @returns {Promise<Message>}
   */


  _createClass(Message, [{
    key: "edit",
    value: function edit(newText) {
      var _this = this;

      return DataSync.update("/rooms/".concat(this.roomId, "/messages/").concat(this.uid), {
        text: newText
      }).then(function () {
        _this.text = newText;
        return _this;
      }).catch(Log.r('Message~edit'));
    }
    /**
     * Remove the text message. Only the sender or moderator/owner of the room can remove a message.
     * @returns {Promise}
     */

  }, {
    key: "remove",
    value: function remove() {
      return DataSync.remove("/rooms/".concat(this.roomId, "/messages/").concat(this.uid)).catch(Log.r('Message~remove'));
    }
    /**
     *
     * @param {Room} room The room to send the message to
     * @param {string} text The message
     * @return {Promise<Message>}
     */

  }], [{
    key: "send",
    value: function send(room, text) {
      if (!_cache.default.user) {
        return Promise.reject(new Error('Cannot send a message to the Room without a User being logged in.'));
      }

      var data = {
        from: _cache.default.user.uid,
        _created: DataSync.ts(),
        text: text
      };
      return DataSync.push("_/rooms/".concat(room.uid, "/messages"), data).then(function (pushRef) {
        return DataSync.get("_/rooms/".concat(room.uid, "/messages/").concat(pushRef.name()));
      }).then(function (snapData) {
        return new Message(snapData, room.uid);
      }).catch(Log.r('Message#send'));
    }
  }]);

  return Message;
}();

exports.default = Message;